/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import PropTypes from "prop-types";
import { CopyButton } from "../Common/CopyButton";
import { Button } from "react-bootstrap";
import { htmlToMarkdown } from "../../../../utility/helpers";

/**
 * This component is used to send a given message to chat.
 * @param {string} value The string value to be sent directly to the chat user.
 * @param {(Object) => void} sendMessage This method takes in an object containing the fields message and the contentType.
 * This should pass the given message to the ccp connection.
 * @returns
 */
export const SendResponse = ({ contact, sendMessage, value }) => {
	const handleSend = () => {
		sendMessage({
			message: htmlToMarkdown(value),
			contentType: "text/markdown",
		});
	};

	return (
		<div>
			<Button size="sm" variant="outline-secondary" style={{ height: "31px", textAlign: "center", minWidth: "50px" }}>
				<div style={{ margin: "auto" }}>
					<CopyButton value={htmlToMarkdown(value)} buttonText={"Copy"} />
				</div>
			</Button>
			{contact.type === window.connect.ContactType.CHAT && (
				<Button style={{ marginLeft: "5px" }} size="sm" variant="outline-secondary" onClick={handleSend}>
					Send
				</Button>
			)}
		</div>
	);
};

SendResponse.propTypes = {
	value: PropTypes.string.isRequired,
};
